import { types, actions } from './requests'
export const DELETEWORKER_TYPES = {
    ...types('DELETEWORKER'),
}
export const DELETEWORKER_ACTIONS = {
    ...actions('DELETEWORKER'),
}
